import type { ElementType, ReactNode } from 'react';
import { CdLogo } from '../../atoms/CdLogo';
import { cx } from '../../utils';
import styles from './CdSiteFooter.module.scss';

export interface FooterLink {
  label: string;
  href: string;
}

export interface CdSiteFooterProps {
  links: FooterLink[];
  copyright: string;
  linkAs?: ElementType;
  /** Optional language picker (e.g. `CdLanguageSelect tone="onDark"`), shown in the `full` variant. */
  languageSelect?: ReactNode;
  /** `full` = navy footer with logo and links (public pages); `compact` = copyright bar (app, mobile). */
  variant?: 'full' | 'compact';
  className?: string;
}

export const CdSiteFooter = ({
  links,
  copyright,
  linkAs,
  languageSelect,
  variant = 'full',
  className,
}: CdSiteFooterProps) => {
  const Anchor = linkAs ?? 'a';
  return (
    <footer className={cx(styles.footer, styles[variant], className)}>
      {variant === 'full' && (
        <span className={styles.logo}>
          <CdLogo tone="onDark" />
        </span>
      )}
      {variant === 'full' && links.length > 0 && (
        <nav aria-label="Footer" className={styles.nav}>
          <ul className={styles.links}>
            {links.map((l) => (
              <li key={l.href}>
                <Anchor href={l.href} className={styles.link}>
                  {l.label}
                </Anchor>
              </li>
            ))}
          </ul>
        </nav>
      )}
      {variant === 'full' && languageSelect && (
        <div className={styles.language}>{languageSelect}</div>
      )}
      <p className={styles.copyright}>{copyright}</p>
    </footer>
  );
};
